import { tags } from '~features/tags/tagNames';
import { useUserTags } from '~features/tags/useUserTags';

export const useDiscordConnected = () => {
	const { userTags, isLoading, isSuccess } = useUserTags();

	const discordConnected = userTags.includes(tags.discordConnected);

	return { discordConnected, isLoading, isSuccess };
};
